/**
 * This file contains the main App component which renders different screens
 * based on the state of the Redux store.
 * It imports React and several components from the './components' directory.
 * It also imports the 'useSelector' hook from 'react-redux' to access the state of the Redux store.
 */

import React from 'react'
import { useSelector } from 'react-redux'
import HomeScreen from './components/Homescreen'
import Render3DComponent from './components/Render3DComponent'
import Instructions from './components/Instructions'
import ModelSelector from './components/ModelSelector'
import RenderAR from './components/RenderAR'

/**
 * The App component is a functional component that renders different screens
 * based on the state of the Redux store.
 * It uses the 'useSelector' hook to access the 'screens' and 'models' state from the Redux store.
 * It then renders the appropriate screen based on the values of 'homeScreen',
 * 'instructionsScreen', and 'arScreen'.
 * If 'arScreen' is true and 'questions' is not equal to 3, it renders both the
 * 'ModelSelector' and 'Render3DComponent' components.
 * If 'arScreen' is true and 'questions' is equal to 3, it renders the 'RenderAR' component
 */
const App = () => {
  const { homeScreen, instructionsScreen, arScreen } = useSelector(({ screens }) => screens)
  const { questions } = useSelector(({ models }) => models)

  const renderScreen = () => {
    if (homeScreen) {
      return <HomeScreen />
    }
    if (instructionsScreen) {
      return <Instructions />
    }
    if (arScreen) {
      return (
        <>
          {questions !== 4
            ? (
            <>
              <ModelSelector />
              <Render3DComponent />
            </>
              )
            : (
            <RenderAR />
              )}
        </>
      )
    }
    return null
  }

  return <div>{renderScreen()}</div>
}

export default App
